export { FontList } from '@tencent/docs-scenario-components-font-list';
